import { useCallback, useMemo, useState, useEffect, useLayoutEffect, useRef } from 'react'
import DataTable, { createTheme } from 'react-data-table-component'
import { datatableTheme } from '../../data/dataTableTheme'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom"
import { RiDirectionFill } from 'react-icons/ri'
import InlineTextField from '../../components/snippets/InlineTextField'
import DatatableLoader from "../../components/snippets/DatatableLoader"
// import QuickAction from '../../components/snippets/QuickAction'
import API from '../../axios/API'
import { AnimatePresence, motion } from 'framer-motion'
import { PopInAnim } from '../../commons/anims'
import Dialog from '../../components/snippets/Dialog'
// import ClosedCaseDialog from '../Dialogs/ClosedCaseDialog'
import TableSettings from '../../components/snippets/TableSettings'
// import TableSelectFilter from '../../components/snippets/TableSelectFilter'
import { FaLayerGroup } from 'react-icons/fa'
import PopoverMenu from '../../components/snippets/PopoverMenu'
import TransferCaseDialog from '../Dialogs/TransferCaseDialog';
import { setAlert } from '../../store/theme/actions'
import { setReopencasecount } from '../../store/auth/actions'
import NotesDialog from '../Dialogs/NotesDialog' 
import { useTranslation } from 'react-i18next'
import QuickActionMultiRole from '../QuickAction'
import axios from 'axios'
import 'moment-timezone';
import moment from 'moment';
import VipButton from "../../components/snippets/VipButton";
import Empty from '../../components/Empty'
import SelectColumn from '../../components/snippets/SelectColumn'
import TableSelectFilter from '../../components/snippets/TableSelectFilter'


createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)
var caseListSelected = []

const ClosedCase = ({history}) => {

    const [filter, setFilter] = useState('')
    const [page, setPage] = useState(1)
    const [records,setRecords] = useState(false);
    const [totalPage, setTotalPage] = useState()
    const [closeCaseDetails, setCloseCaseDetails] = useState([])
    const [selectRows, setSelectedRows] = useState([])
    const { screenSize, themeMode } = useSelector(state => state.theme)
    const [loading, setLoading] = useState(true)
    const [openMultiAction, setOpenMultiAction] = useState(false)
    const organization = useSelector(state => state.auth.organization)
    const userDetails = useSelector(state => state.auth.userDetails)
    const [activeQuickAction] = useState({ position: 'bottom', active: null })
    const [columnsSelected, setColumnsSelected] = useState([])
    const caseTable = useRef(null)
    const [caseId, setCaseId] = useState([])
    const [transferCaseModal, setTransferCaseModal] = useState(false)
    const closecaseRender = useSelector(state => state.auth.closeCaseRender)
    const transfercaseRender = useSelector(state => state.auth.transferCaseRender)
    const dispatch = useDispatch()
    const [notesDialogModal, setNotesDialogModal] = useState(false)
    const [perPage, setPerPage] = useState(10);
    const [sizePage] = useState([10]);
    const [totalRows, setTotalRows] = useState(0);
    const [column,setColumn] = useState()
    const [sortDirection,setSortDirection] = useState()
    const [triggerAll, setTriggerAll] = useState(false)
    const [statusList, setStatusList] = useState([])
    const [statusFilter, setStatusFilter] = useState()
    const reopencount = useSelector(state => state.auth.reopencaseCount)
    const { t } = useTranslation()
    const language = useSelector(state=>state.theme.language)
    let orgId = localStorage.getItem('orgid')
    let vipEnable = localStorage.getItem('vipEnable')
    const [selectSearch, setSelectSearch] = useState([])    
    const [columnSelect, setColumnSelect] = useState(1)
    const [tempSelected,setTempSelected] = useState([])
    let lang= localStorage.getItem('language')
    let enhanceClose = localStorage.getItem('enhanceClose')
    const [secondryList,setSecondryList] = useState([])
    const [secondryFilter,setSecondryFilter] = useState()
    const [hideColumn, setHideColumn] = useState(true)
    const [hideReason,setHideReason] = useState(true)
    useEffect(() => {

        //Page navigation handled using sessionstorage
       var pageView = sessionStorage.getItem('pageView');
       var sort = sessionStorage.getItem('sort');
       var direction = sessionStorage.getItem('direction');
       if(pageView){
        setPage(parseInt(pageView));
        sessionStorage.removeItem('pageView');
       }
       if(sort){        
        setColumn(sort);
        sessionStorage.removeItem('sort');
       }
       if(direction){
        setSortDirection(direction);
        sessionStorage.removeItem('direction');
       }
       if(enhanceClose === 'true'){
        setHideColumn(true)
        setHideReason(false)
       }
        setLoading(true);
        if (history.location.state !== undefined && history.location.state.state.from === 'GeneralSearch') {
            setFilter('')

        setCloseCaseDetails([])
        history.location.state.state.list.forEach((e, i) => {
            history.location.state.state.list[i].caseLastUpdated = lastdat(history.location.state.state.list[i].caseLastUpdated)
            history.location.state.state.list[i].caseReminderDate = remaindat(history.location.state.state.list[i].caseReminderDate)
            history.location.state.state.list[i].dateClosed = datecon(history.location.state.state.list[i].dateClosed)
        })
        setCloseCaseDetails(history.location.state.state.list)
        setTotalRows(history.location.state.state.list.length)
        setLoading(false)
    } else {
        // let path = statusFiltepage ? `page=${page}&size=${perPage}` : page && perPage ? `page=${page}&size=${perPage}` : statusFilter && perPage ? `size=${perPage}&status=${statusFilter}` : `page=${page}&size=${perPage}`
        let path = column && filter && statusFilter && secondryFilter ? `page=${page}&size=${perPage}&search=${filter}&searchField=${columnSelect}&sort=${column},${sortDirection}&primaryReason=${statusFilter}&secondaryReason=${secondryFilter}` : 
        column && statusFilter && secondryFilter ? `page=${page}&size=${perPage}&sort=${column},${sortDirection}&primaryReason=${statusFilter}&secondaryReason=${secondryFilter}` : pageView && column !== undefined && sortDirection !== undefined ? `page=${page}&size=${perPage}&sort=${column},${sortDirection}` : 
        filter && filter !== undefined && statusFilter && secondryFilter ? `page=${page}&size=${perPage}&search=${filter}&searchField=${columnSelect}&primaryReason=${statusFilter}&secondaryReason=${secondryFilter}` :column && filter ? `page=${page}&size=${perPage}&search=${filter}&searchField=${columnSelect}&sort=${column},${sortDirection}`: 
        column  ? `page=${page}&size=${perPage}&sort=${column},${sortDirection}`:filter && filter !== undefined ? `page=${page}&size=${perPage}&search=${filter}&searchField=${columnSelect}`:statusFilter && secondryFilter ? `page=${page}&size=${perPage}&primaryReason=${statusFilter}&secondaryReason=${secondryFilter}`:
        statusFilter ? `page=${page}&size=${perPage}&primaryReason=${statusFilter}`:secondryFilter ? `page=${page}&size=${perPage}&secondaryReason=${secondryFilter}`:
         `page=${page}&size=${perPage}`
        // history.location.state = undefined
        axios.all([API.get(`primaryCloseReason`),API.get(`secondaryCloseReason`),API.get(`fields?screenName=closed&closedReason=${enhanceClose === 'true'? 1 :0}`), API.get(`organizations/${organization}/cases?queue=closed&${path}`),API.get(`menus/case-searchFields?screenName=closed?lang=${lang}`)]).then(axios.spread(
            (statusResp,secondResp,closeCaseResp, closeCaseActive,allColumnSelect) => {
                let details = []
                setCloseCaseDetails([])
                closeCaseResp.data.body.map(c => {
                    details.push({ id: c.fieldId, name: c.fieldName, active: c.active })
                    return null;
                })
                setColumnsSelected(details)
                setStatusList([{ text: (t('All')), value: (('All')) },...statusResp.data.body.map((c) => ({ text: c.statusName, value: c.statusId }))])
                setSecondryList([{ text: (t('All')), value: (('All')) },...secondResp.data.body.map((c) => ({ text: c.statusName, value: c.statusId }))])
                setSelectSearch([...allColumnSelect.data.body.map((c) => ({ text: c.name, value: c.value }))])
                setTotalRows(closeCaseActive.data.page.totalElements)
                setTotalPage(closeCaseActive.data.page.totalPages)
                if((!closeCaseActive.data._embedded && page > 1) || (!closeCaseActive.data._embedded && (closecaseRender ||  transfercaseRender ||reopencount))){
                    setRecords(true)
                    setFilter('')
                }else{
                    setRecords(false)
                }
                closeCaseActive.data._embedded.immutableCaseList.forEach((e, i) => {
                    closeCaseActive.data._embedded.immutableCaseList[i].caseLastUpdated = lastdat(closeCaseActive.data._embedded.immutableCaseList[i].caseLastUpdated)
                    closeCaseActive.data._embedded.immutableCaseList[i].caseReminderDate = remaindat(closeCaseActive.data._embedded.immutableCaseList[i].caseReminderDate)
                    closeCaseActive.data._embedded.immutableCaseList[i].dateClosed = datecon(closeCaseActive.data._embedded.immutableCaseList[i].dateClosed)
                })
                setCloseCaseDetails(closeCaseActive.data._embedded.immutableCaseList)
                setLoading(false)

            }
        )).catch(e => {
            console.log(e)
        }).finally(() => setLoading(false))
    }
        // axios.all([API.get(`fields?screenName=closed`), API.get(`organizations/${organization}/cases?queue=closed`)]).then(axios.spread(
        //     (allCaseResp, allCaseActive) => {
        //         let details = []
        //         allCaseResp.data.body.map(c => {
        //             details.push({ id: c.fieldId, name: c.fieldName, active: c.active })
        //             return null;
        //         })
        //         setColumnsSelected(details)
        //         // console.log(allCaseActive.data._embedded.immutableCaseList, closeCaseActiveResp.data._embedded.immutableCaseList)
        //         allCaseActive.data._embedded.immutableCaseList.forEach((e,i)=>{
        //             allCaseActive.data._embedded.immutableCaseList[i].caseLastUpdated=lastdat(allCaseActive.data._embedded.immutableCaseList[i].caseLastUpdated)
        //             allCaseActive.data._embedded.immutableCaseList[i].caseReminderDate=remaindat(allCaseActive.data._embedded.immutableCaseList[i].caseReminderDate)
        //             // allCaseActive.data._embedded.immutableCaseList[i].followupDate=follow(allCaseActive.data._embedded.immutableCaseList[i].followupDate)
        //             allCaseActive.data._embedded.immutableCaseList[i].dateClosed=datecon(allCaseActive.data._embedded.immutableCaseList[i].dateClosed)
        //         })
        //         setCloseCaseDetails(allCaseActive.data._embedded.immutableCaseList)
        //         setLoading(false)
              
        //     }
        // )).catch(e => {
        //         console.log(e)
        //     }).finally(() => setLoading(false))
 
        // API.get(`fields?screenName=closed`).then((res) => {
        //     if (res.data.body.length === 0) {

        //     } else {
        //         let details = []
        //         res.data.body.map(c => {
        //             details.push({ id: c.fieldId, name: c.fieldName, active: c.active })
        //             return null;
        //         })
        //         setColumnsSelected(details);
        //     }
        // })
        // API.get(`organizations/${organization}/cases?queue=closed`).then((res) => {
        //     console.log(res);
        //     setCloseCaseDetails(res.data._embedded.immutableCaseList);
        //     closeCaseDetails.data._embedded.immutableCaseList.forEach((e,i)=>{
        //         closeCaseDetails.data._embedded.immutableCaseList[i].caseLastUpdated=lastdat(closeCaseDetails.data._embedded.immutableCaseList[i].caseLastUpdated)
        //         closeCaseDetails.data._embedded.immutableCaseList[i].caseReminderDate=lastdat(closeCaseDetails.data._embedded.immutableCaseList[i].caseReminderDate)
        //         closeCaseDetails.data._embedded.immutableCaseList[i].dateClosed=datecon(closeCaseDetails.data._embedded.immutableCaseList[i].dateClosed)
        //     })
        // }).catch(e => {
        //     console.log(e)
        // }).finally(() => setLoading(false))
    }, [organization, closecaseRender, transfercaseRender, reopencount,language, triggerAll, page]) // eslint-disable-line

    const enableColumns = () => {
        let details = []
        columnsSelected.map(c => {
            details.push(
                {
                    "fieldId": c.id,
                    "fieldName": c.name,
                    "active": c.active
                }
            )
            return null;
        })
        API.post(`fields?screenName=closed`, details).then((res) => {
        })

    }

    const datecon =(value)=>
    {if(value !== null && value){
     let timestamp = new Date(value).getTime();
     let tz = moment.tz.guess()
     let tzabbr = moment.tz.zone(tz).abbr(timestamp)
             let followupdate = new Date(value)
         return `${followupdate.toUTCString().slice(8,11)}${followupdate.toUTCString().slice(4,7)}, ${followupdate.toUTCString().slice(11,16)} ${moment(value).format("HH:mm:ss")} ${tzabbr}`
         }else{
             return ''
         }
      }
      const lastdat =(value)=>
      {if(value !== null && value){
       let timestamp = new Date(value).getTime();
       let tz = moment.tz.guess()
       let tzabbr = moment.tz.zone(tz).abbr(timestamp)
               let followupdate = new Date(value)
           return `${followupdate.toUTCString().slice(8,11)}${followupdate.toUTCString().slice(4,7)}, ${followupdate.toUTCString().slice(11,16)} ${moment(value).format("HH:mm:ss")} ${tzabbr}`
           }else{
               return ''
           }
        }
        const remaindat =(value)=>
        {if(value !== null && value){
        //  let timestamp = new Date(value).getTime();
        //  let tz = moment.tz.guess()
        //  let tzabbr = moment.tz.zone(tz).abbr(timestamp)
                 let followupdate = new Date(value)
             return `${followupdate.toUTCString().slice(8,11)}${followupdate.toUTCString().slice(4,7)}, ${followupdate.toUTCString().slice(11,16)}`
             }else{
                 return ''
             }
          }

          const caseNavigation = (value) => {
            sessionStorage.setItem('pageView', page.toString());
            sessionStorage.setItem('sort', column);
            sessionStorage.setItem('direction', sortDirection);
        }

    const colums = useMemo(() => {
        return [
            {
                name:' ',
                selector:'',
                cell: row => {return ((userDetails.orgId === parseInt(organization) && (userDetails.role.includes('caremanager') || userDetails.role.includes('admin'))) || (userDetails.orgId !== parseInt(organization) && (userDetails.role.includes('dynamic_cm') || userDetails.role.includes('dynamic_admin'))) ? <QuickActionMultiRole role={userDetails.role} screen={'closeCases'} asstype={row.assessType} caseId={row.caseId}/>:'') },
                allowOverflow: true,
                button: true,
                width: '56px', // custom width for icon button
            },
            { name: t('Case #'), selector: 'caseId', cell: row => <div aria-label={`Case ${row.caseId}`}>{<Link to={`/casedata/${row.caseId}`} onClick={() => caseNavigation(row)}>{row.caseId}</Link>}</div>,style:{cursor: "pointer","& :hover": {textDecoration: "underline"}}, initialActive: true, sortable: true, sortField: 'SORT_CASE_ID'  },
            { name: t('SubscriberID'), selector: 'subscriberId',cell:row=><span tabIndex={0}>{row.subscriberId}</span>, sortable: true, sortField: 'SORT_SUBSCRIBER_ID' },
            { name: t('Program Name'), selector: 'programName',cell:row =><span aria-label={`Program name ${row.programName}`} tabIndex={0}>{row.programName}</span>, sortable: true,sortField: 'SORT_PROGRAM_NAME' },
            { name: t('Care Manager Name'), selector: 'caremanagerName',cell: row =><span aria-label={`caremanagerName ${row.caremanagerName}`} tabIndex={0}>{row.caremanagerName !== 'null null' ? row.caremanagerName : ''}</span> , sortable: true, hide: 'md', initialActive: true,sortField: 'SORT_CARE_MANAGER_NAME' },
            {
                name: t('Referred by'),
                selector:'referredByName',cell: row => <span aria-label={`Referred by ${row.referredByName}`} tabIndex={0}>{row.referredByName !== "null null" ? row.referredByName : ''}</span>,
                sortable: true,wrap: true,sortField: 'SORT_REFERRED_BY'
            },
            { name: t('Caregiver Name'), selector:'caregiverName', cell: row => <div aria-label={`Caregiver Name ${row.caregiverName}`} tabIndex={0} data-private="lipsum">{row.caregiverName !== 'null null' ? row.caregiverName : ''}</div>, wrap: true, sortable: true, initialActive: true, sortField: 'SORT_CAREGIVER_NAME'},
            // { name: t('Care Receiver Name'), selector: row => { return (row.careReceiverName !== 'null null' ? row.careReceiverName : '') }, sortable: true, initialActive: true },
            { name: t('Care Receiver Name'), selector:'careReceiverName', cell: row => { return <div aria-label={`Care Receiver Name ${row.careReceiverName}`} tabIndex={0} data-private="lipsum" style={{display:'flex'}}> {vipEnable === 'true' && row.vipStatus === true ? <button><VipButton /></button> :<button><Empty/></button>}&nbsp;<span style={{display:'flex'}}>{row.careReceiverName !== 'null null' ? row.careReceiverName  : ''}</span></div> }, sortable: true ,wrap: true, initialActive: true, sortField: 'SORT_CARE_RECEIVER_NAME'},
            { name: t('Care Receiver County'), selector: 'county',cell:row =><span aria-label={`Care Receiver County ${row.county}`} tabIndex={0}>{row.county}</span>, sortable: true,wrap: true, sortField: 'SORT_CARE_RECEIVER_COUNTY'},
            { name: t('Relationship'), selector: 'relationship',cell:row=><span aria-label={`Relationship ${row.relationship}`} tabIndex={0}>{row.relationship}</span>, sortable: true, initialActive: true,wrap: true, sortField: 'SORT_RELATIONSHIP' },
            // { name: t('Reminders'), selector: row => { return <div style={{wordWrap:'break-word',padding:'10px',whiteSpace:'normal',width:'auto',maxHeight:'65px'}}>{row.reminderNotes}</div>} },
            { name: t('Status'), selector: 'caseStatus',  cell:row =><span aria-label={`Status ${row.caseStatus}`} tabIndex={0}>{row.caseStatus}</span>, initialActive: true,sortable: true,wrap: true, sortField: 'SORT_STATUS' },
            {
                name: t('Date Closed'), selector: row => row.dateClosed,cell: row => <span aria-label={`Date Closed ${row.dateClosed}`} tabIndex={0}>{row.dateClosed}</span>,sortable: true,wrap: true, sortField: 'SORT_DATE_CLOSED'
            },
            {
                name: t('Closed Reason'), omit:hideColumn,  selector: 'closedReason',cell:row =><span aria-label={`Closed Reason ${row.closedReason}`} tabIndex={0}>{row.closedReason}</span>, sortable: true,wrap: true, sortField: 'SORT_CLOSED_REASON'
            },
            {
                name: <>{t('Primary Close Case Reason')}<TableSelectFilter options={statusList} label={t("Primary Reason")} defaultValue={''} value={statusFilter} setValue={value => changePrimaryStatus(value)} injectClass="p-1" /></>,omit:hideReason, selector: 'primaryClosedReason',cell:row =><span aria-label={`Primary Close Case Reason ${row.primaryClosedReason}`} tabIndex={0}>{row.primaryClosedReason}</span>,wrap: true, sortField: 'SORT_PRIMARY_CLOSED_REASON'
            },
            {
                name: <>{t('Secondary Close Case Reason')}<TableSelectFilter options={secondryList} label={t("Secondary Reason")} defaultValue={''} value={secondryFilter} setValue={value => changeSecondryStatus(value)} injectClass="p-1" /></>,omit:hideReason, selector: 'secondaryClosedReason',cell:row =><span aria-label={`Secondary Close Case Reason ${row.secondaryClosedReason}`} tabIndex={0}>{row.secondaryClosedReason}</span>,wrap: true, sortField: 'SORT_SECONDARY_CLOSED_REASON'
            },
            // { name: t('Reminder Date'), selector: row => (row.caseReminderDate !== null ) ? row.caseReminderDate :'' , sortable: true ,wrap: true},
            { name: t('Last Updated'),selector:'caseLastUpdated' ,cell:row =><span aria-label={`Last Updated ${row.caseLastUpdated}`} tabIndex={0}> {row.caseLastUpdated !== null ? row.caseLastUpdated : ''}</span>,sortable: true ,wrap: true, sortField: 'SORT_LAST_UPDATE'},
            // { name: 'Case Notes', selector: 'notesLastModified', sortable: true, cell: row => <Link to={``}><FaStickyNote size="20px" className="text-gray-600 dark:text-gray-300" /></Link> }

            // {name: 'Action', button: true, cell: row => <Link to={`/caregiver/${row.id}`}><FaEye size="20px" className="text-gray-600 dark:text-gray-300" /></Link>}
        ].map(c => {
            if (c.name !== undefined && columnsSelected.find(e => e.name === c.name)) c.omit = !columnsSelected.find(e => e.name === c.name).active
            return c
        })
    }, [activeQuickAction, columnsSelected,statusFilter,closeCaseDetails]) // eslint-disable-line
    useLayoutEffect(() => {
        setColumnsSelected(colums.filter(c => c.name !== undefined && c.optionalColumn !== false).map(c => ({ name: c.name, active: c.initialActive || false })))
    }, []) // eslint-disable-line    
    const SubHeader = useMemo(() => (
        <div className="flex items-center relative">
            <InlineTextField label="Search" value={filter} setValue={setFilter} onEnter={() => searchRecords()} onClick={() => searchRecords()} onClose={() => closeFilter()} />
            <span aria-label='Search Select'><SelectColumn options={selectSearch} label={t("Select Search")} value={columnSelect} setValue={value => changeSelect(value)} injectClass="p-1" /></span>
            <TableSettings columns={columnsSelected} setColumns={((columns) => { setColumnsSelected(columns); enableColumns() })} />
        </div>
    ), [filter, columnsSelected,columnSelect,selectSearch]) // eslint-disable-line
    const filteredcasedetails = useMemo(() => {
        let filterSplit = filter.toString().toLowerCase().split(' ')
        return closeCaseDetails.filter(c => filter === '' || filter === null || filterSplit)
    }, [closeCaseDetails, filter])
    const ExpandComponent = useCallback(row => {
        return (
            <div className="bg-bluegray-300 dark:bg-ldark py-2 px-3" key={row.data.caseId}>
                {
                    Object.keys(row.data).map(c => (
                        <div className="flex flex-col my-1">
                            <span className="text-xs text-gray-500 dark:text-gray-300">{c.split('_').map(e => (`${e[0].toUpperCase()}${e.slice(1,).toLowerCase()}`)).join(' ')}</span>
                            <span className="text-sm" >{row.data[c]}</span>
                        </div>
                    ))
                }
            </div>
        )
    }, [])
    const rowsSelected = useCallback(({ selectedRows }) => {
        caseListSelected = tempSelected.map(c => c) 
        let DatacaseIds = closeCaseDetails.map(c => c.caseId)
        let tempcase = tempSelected.filter(c => !DatacaseIds.includes(c.caseId))
        selectedRows.forEach(c =>{
            tempcase.push(c)
        })
        // setCaseId(selectedRows.map(c => c.caseId))
        // setSelectedRows(selectedRows)
        setTempSelected(tempcase)
    }, [tempSelected,closeCaseDetails])
    
    useEffect(() => {
        setCaseId(tempSelected.map(c => c.caseId))
        setSelectedRows(tempSelected)
    }, [tempSelected])

    useEffect(() =>{
        setTempSelected([])
        setSelectedRows([])
        setCaseId()
    },[closecaseRender, transfercaseRender, reopencount])
    const reopenCase = (c) => {
        if (c !== undefined) {
            API.post(`cases:reopen?orgId=${orgId}`, [c]).then(res => {
                if (res.status === 200) {
                    dispatch(setAlert({ title: t('Success'), subtitle: t('Case Reopened Successfully'), type: 'success', active: true }))
                    dispatch(setReopencasecount(reopencount + 1))
                }
            }).catch(e => {
                console.log(e)
            })
        } else {
            setCaseId([caseId])
        }
        API.post(`cases:reopen?orgId=${orgId}`, caseId).then(res => {
            if (res.status === 200) {
                dispatch(setAlert({ title: t('Success'), subtitle: t('Case Reopened Successfully'), type: 'success', active: true }))
                dispatch(setReopencasecount(reopencount + 1))
            }
        }).catch(e => {
            console.log(e)
        })
    }

    const openTransferCaseModal = (c) => {
        if (c !== undefined)
            setCaseId([c])
        setTransferCaseModal(true)
    }

    const closeFilterStatus = () => {
        setRecords(false)
        setPage(1)
        setColumn()
        setSortDirection()
        setFilter('')  
        setTriggerAll(!triggerAll)
    }
    // const openCreateNotesModal = (c) => {
    //     if (c !== undefined) {
    //         setCaseId(c)
    //         setNotesDialogModal(true)
    //     } else {
    //         setCaseId(selectRows)
    //         setNotesDialogModal(true)
    //     }
    // }
    
    const closeFilter = () => {
        setPage(1)
        setStatusFilter()
        setColumn()
        setSortDirection()
        setColumnSelect(1)
        // changeStatus('All Status')
        setTriggerAll(!triggerAll)
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);
        setCloseCaseDetails([])
        setPerPage(sizePage);
        let apiPath = statusFilter ? `size=${newPerPage}&status=${statusFilter}` : `page=${page}&size=${newPerPage}`
        API.get(`organizations/${organization}/cases?queue=closed&${apiPath}`).then((res) => {
            if (res.status === 200) {
                setTotalRows(res.data.page.totalElements)
                setPerPage(res.data.page.size)
                res.data._embedded.immutableCaseList.forEach((e, i) => {
                    res.data._embedded.immutableCaseList[i].caseLastUpdated = lastdat(res.data._embedded.immutableCaseList[i].caseLastUpdated)
                    res.data._embedded.immutableCaseList[i].caseReminderDate = remaindat(res.data._embedded.immutableCaseList[i].caseReminderDate)
                    res.data._embedded.immutableCaseList[i].dateClosed = datecon(res.data._embedded.immutableCaseList[i].dateClosed)
                })
                setCloseCaseDetails(res.data._embedded.immutableCaseList)
            }
        })
        setLoading(false);
        // sizeHandling(newPerPage)
    };

    if ((!loading && history.location.state === undefined && (filteredcasedetails.length >= 10 || closeCaseDetails.length >= 10)) || (!loading && (filteredcasedetails.length >= 10 || closeCaseDetails.length >= 10))) {
        if (page > 1) {
            // document.getElementById('pagination-next-page')?.removeAttribute('disabled')
            document.getElementById('pagination-first-page')?.removeAttribute('disabled')
            document.getElementById('pagination-first-page')?.addEventListener(('click'), () => {
                setPage(1)
            })
        }
        document.getElementById('pagination-next-page')?.addEventListener(('click'), () => {
            setPage(page + 1)
        })
        document.getElementById('pagination-last-page')?.addEventListener(('click'), () => {
            //setPage(totalPage)
        })
        if (page > 1) {
            document.getElementById('pagination-previous-page')?.removeAttribute('disabled')
            document.getElementById('pagination-previous-page')?.addEventListener(('click'), () => {
                setPage(page - 1)
            })
        }
    }  else if (!loading && page > 1 && filteredcasedetails.length < 10 && closeCaseDetails.length < 10) {
        document.getElementById('pagination-previous-page')?.removeAttribute('disabled')
        document.getElementById('pagination-previous-page')?.addEventListener(('click'), () => {
            setPage(page - 1)
        })
        document.getElementById('pagination-first-page')?.removeAttribute('disabled')
        document.getElementById('pagination-first-page')?.addEventListener(('click'), () => {
            setPage(1)
        })
    } else if (filteredcasedetails.length < 10 && closeCaseDetails.length < 10 && !loading && history.location.state === undefined) {
        document.getElementById('pagination-next-page')?.setAttribute('disabled', true)
        document.getElementById('pagination-first-page')?.setAttribute('disabled', true)
        document.getElementById('pagination-last-page')?.setAttribute('disabled', true)
        document.getElementById('pagination-previous-page')?.setAttribute('disabled', true)
    }else {
        document.getElementById('pagination-next-page')?.setAttribute('disabled', true)
        document.getElementById('pagination-first-page')?.setAttribute('disabled', true)
        document.getElementById('pagination-last-page')?.setAttribute('disabled', true)
        document.getElementById('pagination-previous-page')?.setAttribute('disabled', true)
    }

 

    const changeSelect = (value) => {
        selectSearch.map((c) => {
            if (c.value === value) {
                setColumnSelect(value)
            }
            return c
        })
    }

    const changePrimaryStatus = (value) => {
        statusList.map((c) => {
            if (c.value === value) {
                setStatusFilter(c.value)
            }
            return c
        })
        let apiPath = value && value !== 'All' && column && filter && secondryFilter && secondryFilter !== 'All' ? `size=${perPage}&primaryReason=${value}&secondaryReason=${secondryFilter}&search=${filter}&searchField=${columnSelect}&sort=${column},${sortDirection}` : 
        value && value !== 'All'&& column && filter ? `size=${perPage}&primaryReason=${value}&search=${filter}&searchField=${columnSelect}&sort=${column},${sortDirection}`:
        value && value !== 'All'&& column &&secondryFilter && secondryFilter !== 'All' ? `size=${perPage}&primaryReason=${value}&secondaryReason=${secondryFilter}&searchField=${columnSelect}&sort=${column},${sortDirection}`: 
        value && value !== 'All'&& filter && secondryFilter && secondryFilter !== 'All' ? `size=${perPage}&primaryReason=${value}&secondaryReason=${secondryFilter}&search=${filter}`:
        value && value !== 'All'&& secondryFilter && secondryFilter !== 'All' ? `size=${perPage}&primaryReason=${value}&secondaryReason=${secondryFilter}`:
        value&& value !== 'All' ? `size=${perPage}&primaryReason=${value}`:`page=${page}&size=${perPage}`
        API.get(`organizations/${organization}/cases?queue=closed&${apiPath}`).then((res) => {
            if(value === 'All' || secondryFilter === 'All'){
                setStatusFilter()
                setSecondryFilter()
            }
            if (res.status === 200 && res.data._embedded) {
                setTotalRows(res.data.page.totalElements)
                setPerPage(res.data.page.size)
                res.data._embedded.immutableCaseList.forEach((e, i) => {
                    res.data._embedded.immutableCaseList[i].caseLastUpdated = lastdat(res.data._embedded.immutableCaseList[i].caseLastUpdated)
                    res.data._embedded.immutableCaseList[i].caseReminderDate = remaindat(res.data._embedded.immutableCaseList[i].caseReminderDate)
                    res.data._embedded.immutableCaseList[i].dateClosed = datecon(res.data._embedded.immutableCaseList[i].dateClosed)
                })
                setCloseCaseDetails(res.data._embedded.immutableCaseList)
            }else{
                setRecords(true)
                setCloseCaseDetails([]) 
                setStatusFilter()
                setSecondryFilter()
            }
        })
    }

    const changeSecondryStatus =(value) =>{
        secondryList.map((c) => {
            if (c.value === value) {
                setSecondryFilter(c.value)
            }
            return c
        })
        let apiPath = statusFilter !== 'All' && column && filter && value && value !== 'All' ? `size=${perPage}&primaryReason=${statusFilter}&secondaryReason=${value}&search=${filter}&searchField=${columnSelect}&sort=${column},${sortDirection}` : 
        value !== 'All' && column && filter ? `size=${perPage}&primaryReason=${statusFilter}&search=${filter}&searchField=${columnSelect}&sort=${column},${sortDirection}`:
        statusFilter && statusFilter !== 'All' && column && value && value !== 'All' ? `size=${perPage}&primaryReason=${statusFilter}&secondaryReason=${value}&searchField=${columnSelect}&sort=${column},${sortDirection}`: 
        statusFilter && statusFilter !== 'All' && filter && value && value !== 'All' ? `size=${perPage}&primaryReason=${statusFilter}&secondaryReason=${value}&search=${filter}`:
        statusFilter && statusFilter !== 'All' && value && value !== 'All' ? `size=${perPage}&primaryReason=${statusFilter}&secondaryReason=${value}`:
        value && value !== 'All' ? `size=${perPage}&secondaryReason=${value}`:`page=${page}&size=${perPage}`
        API.get(`organizations/${organization}/cases?queue=closed&${apiPath}`).then((res) => {
            if(value === 'All' || statusFilter === 'All'){
                setStatusFilter()
                setSecondryFilter()
            }
            if (res.status === 200 && res.data._embedded) {
                setTotalRows(res.data.page.totalElements)
                setPerPage(res.data.page.size)
                res.data._embedded.immutableCaseList.forEach((e, i) => {
                    res.data._embedded.immutableCaseList[i].caseLastUpdated = lastdat(res.data._embedded.immutableCaseList[i].caseLastUpdated)
                    res.data._embedded.immutableCaseList[i].caseReminderDate = remaindat(res.data._embedded.immutableCaseList[i].caseReminderDate)
                    res.data._embedded.immutableCaseList[i].dateClosed = datecon(res.data._embedded.immutableCaseList[i].dateClosed)
                })
                setCloseCaseDetails(res.data._embedded.immutableCaseList)
            }else{
                setRecords(true)
                setCloseCaseDetails([]) 
                setStatusFilter()
                setSecondryFilter()
            }
        })
    }

    const searchRecords = () => {
        if (filter.length > 0) {
            if(column && column !== undefined) {
                API.get(`organizations/${organization}/cases?queue=closed&page=1&size=${perPage}&search=${filter}&searchField=${columnSelect}&sort=${column},${sortDirection}`).then((res) => {
                    if (res.status === 200 && res.data._embedded) {
                        setPage(1)
                        setCloseCaseDetails([])
                        res.data._embedded.immutableCaseList.forEach((e, i) => {
                            res.data._embedded.immutableCaseList[i].caseLastUpdated = lastdat(res.data._embedded.immutableCaseList[i].caseLastUpdated)
                            res.data._embedded.immutableCaseList[i].caseReminderDate = remaindat(res.data._embedded.immutableCaseList[i].caseReminderDate)
                            res.data._embedded.immutableCaseList[i].dateClosed = datecon(res.data._embedded.immutableCaseList[i].dateClosed)
                        })
                        setCloseCaseDetails(res.data._embedded.immutableCaseList)
                        setTotalRows(res.data.page.totalElements)
                    }else{
                        setRecords(true)
                        setCloseCaseDetails([])
                    }
                })
            }else{
                API.get(`organizations/${organization}/cases?queue=closed&page=1&size=${perPage}&search=${filter}&searchField=${columnSelect}`).then((res) => {
                    if (res.status === 200 && res.data._embedded) {
                        // setPage(1)
                        setCloseCaseDetails([])
                        res.data._embedded.immutableCaseList.forEach((e, i) => {
                            res.data._embedded.immutableCaseList[i].caseLastUpdated = lastdat(res.data._embedded.immutableCaseList[i].caseLastUpdated)
                            res.data._embedded.immutableCaseList[i].caseReminderDate = remaindat(res.data._embedded.immutableCaseList[i].caseReminderDate)
                            res.data._embedded.immutableCaseList[i].dateClosed = datecon(res.data._embedded.immutableCaseList[i].dateClosed)
                        })
                        setCloseCaseDetails(res.data._embedded.immutableCaseList)
                        setTotalRows(res.data.page.totalElements)
                    }else{
                        console.log('test')
                        setRecords(true)
                        setCloseCaseDetails([])
                    }
                })
            }
        }
     
    }
 
    const handleSort = async (column, sortDirection) => {
        setTempSelected(caseListSelected.map(c => c))
        setColumn(column.sortField)
        setSortDirection(sortDirection.toUpperCase())
        let apiPath = filter && filter !== undefined ? `size=${perPage}&search=${filter}&searchField=${columnSelect}&sort=${column.sortField}` : `page=1&size=${perPage}&sort=${column.sortField}`;
        API.get(`organizations/${organization}/cases?queue=closed&${apiPath},${sortDirection.toUpperCase()}`).then((res) => {
            if (res.status === 200) {
                res.data._embedded.immutableCaseList.forEach((e, i) => {
                    res.data._embedded.immutableCaseList[i].caseLastUpdated = lastdat(res.data._embedded.immutableCaseList[i].caseLastUpdated)
                    res.data._embedded.immutableCaseList[i].caseReminderDate = remaindat(res.data._embedded.immutableCaseList[i].caseReminderDate)
                    res.data._embedded.immutableCaseList[i].dateClosed = datecon(res.data._embedded.immutableCaseList[i].dateClosed)
                })
                setCloseCaseDetails(res.data._embedded.immutableCaseList)
                setTotalRows(res.data.page.totalElements)
            }
        })
        //   setData(remoteData);
    };
    useEffect(() => {
        caseListSelected = []
        const element = document.querySelectorAll('[aria-label="Expand Row"]');
        if (element) {
            element.forEach((e) => {
                e.setAttribute('role','gridcell')
            })
        }
    },[])

    const rowSelectCritera = (row) => {
        return tempSelected.map(c => c.caseId).includes(row.caseId)
      }
    
    return (
        <div className="p-2 bg-bluegray-200 dark:bg-ddark rounded-lg relative" ref={caseTable}>
            {
                loading ?
                    <DatatableLoader /> :
                    <DataTable title="casedetails" columns={colums} data={filteredcasedetails} theme={themeMode === 'dark' ? "defaultDark" : "defaultLight"} pagination paginationServer={true} noHeader highlightOnHover selectableRows={(userDetails.orgId === parseInt(organization) && (userDetails.role.includes('caremanager') || userDetails.role.includes('admin'))) || (userDetails.orgId !== parseInt(organization) && (userDetails.role.includes('dynamic_cm') || userDetails.role.includes('dynamic_admin'))) ? true : false} 
                    selectableRowSelected={rowSelectCritera}
                    selectableRowsHighlight persistTableHead subHeader onSort={handleSort} 
                    sortServer paginationRowsPerPageOptions={sizePage} paginationTotalRows={totalRows} onChangeRowsPerPage={handlePerRowsChange} subHeaderComponent={SubHeader} onChangePage={val => setPage(val)} paginationDefaultPage={page} expandableRows={screenSize < 3} expandableRowsComponent={<ExpandComponent />} onSelectedRowsChange={rowsSelected} paginationComponentOptions={{ rowsPerPageText: 'Items per page:', rangeSeparatorText: 'of', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'All' }} noDataComponent={t('There are no records to display')} />
            }
           {records ?<div className='flex justify-center' tabIndex={0}> <span onEnter={() => closeFilterStatus()} onClick={() => closeFilterStatus()}><button aria-label="Back to Unassigned Cases" className='bg-tcolor flex px-6 py-0.5 mr-3 mt-3 items-center text-sm'>{t("Click here to Closed Cases")}</button> </span></div> : ''}

            <AnimatePresence>
                {
                    selectRows.length > 0 &&
                    <motion.button variants={PopInAnim} initial="hidden" animate="visible" exit="hidden" className="flex items-center absolute bottom-6 ml-4 rounded text-white text-xs hover:bg-opacity-80" onClick={() => setOpenMultiAction(true)}>
                        <FaLayerGroup size="18px" className="mr-1 text-black dark:text-white" />
                        {selectRows.length > 0 &&
                            <span className="absolute -top-3 left-3/4 bg-tcolor rounded-lg py-0.5 px-1.5 text-[9px]">{selectRows.length}</span>
                        }
                        <PopoverMenu title={`${t('Action')} (${selectRows.length})`} origin="topright" active={openMultiAction} onClose={() => setOpenMultiAction(false)}>
                            {((userDetails.orgId === parseInt(organization) && userDetails.role.includes('admin')) || (userDetails.orgId !== parseInt(organization) && userDetails.role.includes('dynamic_admin'))) ? <div className="pl-4 py-2 w-full flex items-center cursor-pointer hover:text-white hover:bg-gray-500 dark:hover:bg-mdark" onClick={() => openTransferCaseModal()}>
                                <RiDirectionFill size="16px" className="mr-2" />
                                {t("Transfer Case")}
                            </div> : ''}
                           {((userDetails.orgId === parseInt(organization) && (userDetails.role.includes('caremanager') || userDetails.role.includes('admin')))|| (userDetails.orgId !== parseInt(organization) && (userDetails.role.includes('dynamic_cm') || userDetails.role.includes('dynamic_admin')))) ? <div className="pl-4 py-2 w-full flex items-center cursor-pointer hover:text-white hover:bg-gray-500 dark:hover:bg-mdark" onClick={() => reopenCase()}>
                                <RiDirectionFill size="16px" className="mr-2" />
                                {t("Reopen Case")}
                            </div> :''}
                        </PopoverMenu>
                    </motion.button>
                }
            </AnimatePresence>
            <Dialog title="Transfer Case" showDialog={transferCaseModal} onClose={() => setTransferCaseModal(false)}>
                <TransferCaseDialog onClose={() => setTransferCaseModal(false)} caseIds={caseId} />
            </Dialog>
            <Dialog title="Create Notes" showDialog={notesDialogModal} onClose={() => setNotesDialogModal(false)}>
                <NotesDialog onClose={() => setNotesDialogModal(false)} props={caseId} type={'create'} />
            </Dialog>
        </div>
    )
}

export default ClosedCase
